var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Game"},[_c('Canvas',{ref:"canvas",attrs:{"id":"Canvas"}}),(_vm.initialized)?[_c('Bounds',{ref:"bounds"}),_c('Forms',{ref:"forms"})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }